var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 10",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25.625H.75a.438.438 0 00-.438.438V8.5a.875.875 0 00.875.875h9.626a.875.875 0 00.874-.875V1.062a.438.438 0 00-.437-.437zm-10.063 3.5h2.188v1.75H1.187v-1.75zm3.063 0h6.563v1.75H4.25v-1.75zM10.813 1.5v1.75H1.187V1.5h9.626zM1.187 6.75h2.188V8.5H1.187V6.75zm9.626 1.75H4.25V6.75h6.563V8.5z"
  })));
}
export default SvgTable;